import { createContext } from "react";

const CookiesConsentContext = createContext({
  openCookiesSettings: () => {
    return;
  },
});

export default CookiesConsentContext;
